export interface ToggleOption {
  value: string;
  label: string;
}

interface ToggleChipsProps {
  options: ToggleOption[];
  selected: string[];
  onToggle: (value: string) => void;
}

function ToggleChips({ options, selected, onToggle }: ToggleChipsProps) {
  return (
    <div className="flex flex-wrap">
      {options.map(({ value, label }) => (
        <div
          key={value}
          className={`mt-2 border border-black rounded-md p-3 mr-3 cursor-pointer select-none transition-colors ${
            selected.includes(value)
              ? 'bg-black text-white'
              : 'bg-[#f3f4f6] text-black'
          }`}
          onClick={() => onToggle(value)}
          role="button"
          tabIndex={0}
          onKeyDown={e => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              onToggle(value);
            }
          }}
        >
          {label}
        </div>
      ))}
    </div>
  );
}

export default ToggleChips;
